import { theme } from "./theme.css"

export function convertYoutubeURL(url) {
  const regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
  const match = url.match(regExp)

  return match && match[7].length === 11 ? match[7] : null
}

export function checkSection(index) {
  if (index % 2 === 0) {
    return "sectionEven"
  } else {
    return "sectionOdd"
  }
}

export function checkSectionToHex(index) {
  if (index % 2 === 0) {
    return theme.colors.sectionPrimary
  } else {
    return theme.colors.sectionSecondary
  }
}

export function convertDate(date) {
  const dateArray = date.split("-")
  const day = dateArray[2]
  const month = dateArray[1]
  const year = dateArray[0]

  return `${day}.${month}.${year}`
}

export function readingTime(text) {
  const wordsPerMinute = 200
  const words = text.split(" ").length

  return Math.ceil(words / wordsPerMinute)
}
